export const firebaseConfig = {
  apiKey: "AIzaSyBg-Y0EpLBcxWPsIaiPpX97ZTuvk7zMgpA",
  authDomain: "adplex-status.firebaseapp.com",
  projectId: "adplex-status",
  storageBucket: "adplex-status.firebasestorage.app",
  messagingSenderId: "869455927841",
  appId: "1:869455927841:web:5f07a89ba4300ce80f2160",
  measurementId: "G-J23RQ9DQ21"
};